/**
 * Role → home dashboard path resolver.
 *
 * Previously this logic was inlined in 5+ places (Login, Reset password,
 * Change password, Register, Header, CheckoutSuccess…), and every new role
 * we added (SME, staff, …) silently broke whichever spot was missed. SMEs
 * who reset their password were routed to `/dashboard` (student-only),
 * which `ProtectedRoute` then rejected — landing them on the homepage
 * with no way to reach `/sme`.
 *
 * One helper, one canonical mapping.
 */
export function dashboardPathForRole(role) {
    switch (role) {
        case "admin":
        case "super_admin":
            return "/admin";
        case "sme":
            return "/sme";
        case "instructor":
            return "/instructor";
        case "student":
        default:
            return "/dashboard";
    }
}
